import React from 'react';
import { Link } from 'react-router-dom';
import { privacy } from '../privacyContent';

const LABELS = {
  tr: { policy: 'Gizlilik ve Çerez Politikası', cookies: 'Çerez ayarları' },
  en: { policy: 'Privacy Policy', cookies: 'Cookie settings' },
};

// window.plOpenConsent is defined by the consent script in public/index.html; it is absent when no tag ID is built in.
const LegalLinks = ({ lang = 'en', className = '' }) => {
  const t = LABELS[lang] || LABELS.en;
  const canOpenConsent = typeof window !== 'undefined' && typeof window.plOpenConsent === 'function';
  return (
    <p className={`text-sm text-gray-500 ${className}`} data-testid="legal-links">
      <Link to={(privacy[lang] || privacy.en).path} className="hover:text-[#FF6600] transition-colors">{t.policy}</Link>
      {canOpenConsent && (
        <>
          <span className="mx-2 text-gray-700" aria-hidden="true">·</span>
          <button
            type="button"
            onClick={() => window.plOpenConsent()}
            className="hover:text-[#FF6600] transition-colors"
            data-testid="cookie-settings"
          >
            {t.cookies}
          </button>
        </>
      )}
    </p>
  );
};

export default LegalLinks;
